import React from 'react';

import { GRAY_DARK_SHADE_1, VERTICAL_SEPARATOR, WHITE } from '~/Constants/Colors.constants';
import { ErrorButton } from '~/UIKit';
import { ExtendedEventGroup } from '../ExtendedEventGroup.model';
import { makeStyles } from '~/UIKit/Style';
import { EndEventGroupConfirmationModal } from '~/Screens/EventGroupList/EndEventGroupConfirmationModal';
import { DeleteEventGroupConfirmationModal } from '~/Screens/EventGroupList/DeleteEventGroupConfirmationModal';
import { useArchiveEventGroup } from '~/Screens/Events/EventCreate/EventCreateSections/hooks/useArchiveEventGroup';

const useStyles = makeStyles((theme) => ({
  editEventGroupButtonContainer: {
    padding: '30px 0 15px 0',
    [theme.breakpoints.down('md')]: {
      background: GRAY_DARK_SHADE_1,
    },
  },
  editEventGroupButtonButton: {
    width: '100%',
    background: WHITE,
    borderBottom: `thin solid ${VERTICAL_SEPARATOR}`,
    borderTop: `thin solid ${VERTICAL_SEPARATOR}`,
    fontWeight: 300,
  },
  editEventGroupButtonInputPropsRoots: {
    width: '100%',
    maxWidth: '100%',
    minHeight: 150,
  },
}));

export const ArchiveEventGroupButton = ({ eventGroup }: { eventGroup: ExtendedEventGroup }) => {
  const { classes } = useStyles();
  const {
    isLoadingNextEvent,
    onActionClicked,
    actionName,
    endEventGroupOptions,
    onConfirmEndEventGroup,
    onCloseEndEventGroupModal,
    deleteEventGroupOptions,
    onConfirmDeleteEventGroup,
    onCloseDeleteEventGroupModal,
  } = useArchiveEventGroup(eventGroup);

  return (
    <>
      <div className={classes.editEventGroupButtonContainer}>
        {!isLoadingNextEvent && (
          <ErrorButton
            className={classes.editEventGroupButtonButton}
            onClick={onActionClicked}
            variant="text"
            size="large"
          >
            {actionName}
          </ErrorButton>
        )}
      </div>
      {endEventGroupOptions && (
        <EndEventGroupConfirmationModal
          onClose={onCloseEndEventGroupModal}
          onConfirm={onConfirmEndEventGroup}
          confirmationOptions={endEventGroupOptions}
        />
      )}
      {deleteEventGroupOptions && (
        <DeleteEventGroupConfirmationModal
          onClose={onCloseDeleteEventGroupModal}
          onConfirm={onConfirmDeleteEventGroup}
          confirmationOptions={deleteEventGroupOptions}
        />
      )}
    </>
  );
};
